// Driver Profile Types

export interface DriverData {
  id: number;
  userId: number;
  profileState: string;
  hasCanadaExperience: boolean;
  hasUsaExperience: boolean;
  hasInternationalExperience: boolean;
  canadaExperience?: string;
  usaExperience?: string;
  internationalExperience?: string;
  experienceRadius?: string;
  hasRecentAccident: boolean;
  recentAccidentDescription: string;
  hasRecentTicket: boolean;
  recentTicketDescription: string;
  drugAlcohol3Year: boolean;
  canadianCitizen: boolean;
  canadaLiveAndWork: boolean;
  hasValidPassport: boolean;
  passportCountryOrigin: string;
  passportExpiry: Date;
  passportExpiryDate: string;
  passportNumber?: string;
  hasFastPass: boolean;
  fastPassNumber: string;
  hasUsDotNumber: boolean;
  usDotNumber: string;
  usaDenied: boolean;
  canEnterUsa: boolean;
  createdAt: Date;
  updatedAt: Date;
  licenses?: any[];
  certifications?: any[];
  education?: any[];
  employmentHistory?: any[];
  accountabilityFiles?: {
    mvr?: boolean;
    cvordr?: boolean;
    medical?: boolean;
    drugTest?: boolean;
    criminalCheck?: boolean;
  };
}

export interface SnapshotFormData {
  // Experience Section
  experienceRadius: string;
  hasCanadaExperience: boolean | null;
  canadaProvinces: string[];
  canadaExperience: string;
  hasUsaExperience: boolean | null;
  usaStates: string[];
  usaExperience: string;
  hasInternationalExperience: boolean | null;
  internationalExperience: string;

  // Accident/Ticket/Citizenship Section
  hasRecentAccident: boolean | null;
  recentAccidentDescription: string;
  hasRecentTicket: boolean | null;
  recentTicketDescription: string;
  drugAlcohol3Year: boolean | null;
  canadianCitizen: boolean | null;
  canadaLiveAndWork: boolean | null;

  // Passport & ID Section
  canEnterUsa: boolean | null;
  usaEntryStatus: boolean | null;
  hasValidPassport: boolean | null;
  passportNumber: string;
  passportExpiryDate: string;
  passportCountryOrigin: string;
  hasFastPass: boolean | null;
  fastPassNumber: string;
  hasUsDotNumber: boolean | null;
  usDotNumber: string;
}

export interface BooleanState {
  icon: React.ReactNode;
  text: string;
  color: string;
  borderColor?: string;
  textColor?: string;
}

export interface SafetyState extends BooleanState {
  borderColor: string;
  textColor: string;
}

export const CANADIAN_PROVINCES = [
  'Alberta',
  'British Columbia',
  'Manitoba',
  'New Brunswick',
  'Newfoundland and Labrador',
  'Northwest Territories',
  'Nova Scotia',
  'Nunavut',
  'Ontario',
  'Prince Edward Island',
  'Quebec',
  'Saskatchewan',
  'Yukon',
];

export const US_STATES = [
  'Alabama',
  'Alaska',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'Delaware',
  'Florida',
  'Georgia',
  'Hawaii',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa',
  'Kansas',
  'Kentucky',
  'Louisiana',
  'Maine',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana',
  'Nebraska',
  'Nevada',
  'New Hampshire',
  'New Jersey',
  'New Mexico',
  'New York',
  'North Carolina',
  'North Dakota',
  'Ohio',
  'Oklahoma',
  'Oregon',
  'Pennsylvania',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas',
  'Utah',
  'Vermont',
  'Virginia',
  'Washington',
  'West Virginia',
  'Wisconsin',
  'Wyoming',
  'District of Columbia',
];

export const EXPERIENCE_RADIUS_OPTIONS = [
  { value: '', label: 'Not Applicable' },
  { value: 'Up to 80km', label: 'Up to 80km', enum: 'UP_TO_80KM' },
  { value: 'Up to 160km', label: 'Up to 160km', enum: 'UP_TO_160KM' },
  { value: 'Up to 500km', label: 'Up to 500km', enum: 'UP_TO_500KM' },
  { value: 'Up to 1000km', label: 'Up to 1000km', enum: 'UP_TO_1000KM' },
  { value: 'Long Haul (1000km+)', label: 'Long Haul (1000km+)', enum: 'MORE_THAN_1000KM' },
];
